import { FiCalendar } from "react-icons/fi";
import cn from "clsx";
import styles from "./DepartureYearToggle.module.scss";

type DepartureYearButtonProps = {
    year: string;
    onClick: (year: string) => void;
    isActive: (year: string) => boolean;
};

export const DepartureYearButton: React.FC<DepartureYearButtonProps> = ({
    year,
    onClick,
    isActive,
}) => {
    return (
        <button
            onClick={() => onClick(year)}
            className={cn(styles["year-button"], {
                [styles["year-button--active"]]: isActive(year),
            })}
            type="button"
        >
            <span className={styles["calendar-icon"]}>
                <FiCalendar aria-hidden="true" />
            </span>
            {year}
        </button>
    );
};
